import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import Modal from '../../Modal/Modal';
import Heading from '../../Typography/Heading/Heading';
import { useTranslation } from 'react-i18next';
import Button from '../../Button/Button';
import styles from './DeleteGuildModal.module.scss';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import { useNavigate } from 'react-router-dom';
import { deleteGuild as deleteGuildAction } from '../../../store/reducers/Guild/guildRequest';
import cn from 'classnames';
import Loader from '../../Loader/Loader';
import { GuildActionsName } from '../../../store/reducers/Guild/guildType';
import { clearData } from '../../../store/reducers/Guild/slice';
const DeleteGuildModal = ({ closeModal, id }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { error, pending, isDataSent } = useAppSelector((state) => state.guild);
    useEffect(() => {
        if (!error && isDataSent.includes(GuildActionsName.DELETE_GUILD)) {
            closeModal();
            navigate(`/social/all-guilds`);
            dispatch(clearData(GuildActionsName.DELETE_GUILD));
        }
    }, [error, dispatch, closeModal, isDataSent, navigate]);
    return (_jsxs(Modal, Object.assign({ background: true, closeModal: closeModal }, { children: [_jsx(Heading, { className: styles.heading, title: t('are_you_sure_to_want_delete_guild') }), pending.includes(GuildActionsName.DELETE_GUILD) ? (_jsx(Button, { className: cn('w-100'), height: 'sm', size: '100', text: "", icon: _jsx(Loader, { isTransparent: true }) })) : (_jsx(Button, { height: 'sm', size: '100', onClick: () => dispatch(deleteGuildAction(id)), text: t('yes_i_want_to_delete') }))] })));
};
export default DeleteGuildModal;
